// extracted by css-extract-rspack-plugin
export default {"Page":"Index-module__Page__oBqJ2","Section":"Index-module__Section__yeaGT","Container":"Index-module__Container__B479w","Component":"Index-module__Component__MJOJ6"};